import React from 'react'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import withRoot from "../../withRoot";

const styles = theme => ({

  title: {
    color: theme.palette.primary.main,
    fontWeight: "normal",
    textTransform: "uppercase",
    fontSize: 18
  },
  button: {
    background: theme.palette.secondary.main,
    borderRadius: 3,
    border: 0,
    color: 'black',
    padding: 16,
    width: "100%",
  },
  icon: {
    margin: theme.spacing.unit,
    fontSize: 64,
  },
});

const HomeNavButton = (props) => {

  const { classes, title, routePath, Icon } = props;
  
  return (
    <Button className={classes.button} component={Link} to={routePath}>
      <Grid container direction="column" justify="center" alignItems="center" spacing={0}>
        <Grid item xs={12}>
          <Typography className={classes.title} noWrap={true}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Icon className={classes.icon}/>
        </Grid>
      </Grid>
    </Button>
  )
}

export default withRoot(withStyles(styles)(HomeNavButton));



// WEBPACK FOOTER //
// ./src/components/Layout/HomeNavButton.js